export default "__VITE_ASSET__oDxyJ9GO__"